import {AvatarSize} from '@gravity-ui/uikit';

import {InviteeDropdownAvatarProps, UserData} from './UserDropdownAvatar';
import {emptyUserAvatar, isRetina, textSizeMap} from './constants';

function toRetinaAwareUrl(url: string | undefined): string | undefined {
    return isRetina ? url?.replace(/\/islands-(?!retina-)([^/]+)$/, '/islands-retina-$1') : url;
}

export function getYapicUrl(url: string, size: AvatarSize) {
    return `${url}islands${isRetina ? '-retina' : ''}-${textSizeMap[size]}`;
}

export function getEmptyUserAvatar(size: AvatarSize) {
    return getYapicUrl(emptyUserAvatar, size);
}

export function getUserAvatar(user: UserData, size: AvatarSize, internal?: boolean) {
    if (user.avatarData) {
        return `data:image/jpeg;base64,${user.avatarData}`;
    }

    if (internal && user.avatarHost && user.login) {
        return `${user.avatarHost}/api/v1/user/${user.login}/avatar/100.jpg`;
    }

    let avatar = user.avatar || emptyUserAvatar;

    if (user.avatarHost && user.avatarId) {
        // for passport user
        avatar = `${user.avatarHost}/get-yapic/${user.avatarId}/`;
    } else if (user.isFederationUser && user.avatar) {
        // for federation users with link to avatar picture
        return toRetinaAwareUrl(user.avatar);
    } else if (avatar.includes('/islands-')) {
        // Для пользователей в формате claims
        return toRetinaAwareUrl(user.avatar);
    }

    if (avatar.includes('/get-yapic/') && !avatar.includes('/islands-')) {
        return getYapicUrl(avatar, size);
    }

    return avatar;
}

export function isInviteeProps(props: unknown): props is InviteeDropdownAvatarProps {
    return (props as InviteeDropdownAvatarProps).invitee;
}
